import styled, { css } from "styled-components";

export const MenuItem = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-weight: 600;
  line-height: 22px;
  font-size: 15px;
  position: relative;
  cursor: pointer;
  padding: 6px 0;
  flex-basis: 24%;
  flex-grow: 0;

  .icon {
    font-size: 16px;
  }
  &:not(:first-child)::after {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 60%;
    border-left: 1px solid #e5e7eb;
  }

  ${(props) =>
    props.disabled &&
    css`
      color: #434343;
      opacity: 0.5;
      cursor: not-allowed;
    `}
`;
